// extracted by mini-css-extract-plugin
module.exports = {"text":"CopyableText_text__1e1dl","copy":"CopyableText_copy__2V9A4"};